import { useState } from "react";

import { SettingsDialog } from "./SettingsDialog";
import { ReactComponent as EditIcon } from "../../../../../common/icons/editDark.svg";
import { IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  CommonWorkTimeBankSettingMode,
  WorkTimeBankSetting,
} from "../../../../employment/employmentApi";
import { addDays } from "date-fns";
import { useAppSelector } from "../../../../../app/hooks";
import isEmpty from "../../../../../common/helpers/isEmpty";

type Props = {
  timeBankSettings: WorkTimeBankSetting[] | undefined;
  type: "workTimeBank" | "flexiHours";
};

export const WorkTimeBankSettings = ({ timeBankSettings, type }: Props) => {
  const { t } = useTranslation();

  const employment = useAppSelector((state) => state.employment.additionalInfo);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const formattedTimeBankSettings = timeBankSettings?.map((setting, i) => {
    // If last item, 'to' is employment end date (fixed-term) or null
    if (i === timeBankSettings.length - 1) {
      return {
        ...setting,
        from: new Date(setting.from),
        to: employment.details.agreedEnd
          ? new Date(employment.details.agreedEnd)
          : null,
        mode: setting.mode || CommonWorkTimeBankSettingMode.NOT_SET,
      };
    } else {
      const nextItem = timeBankSettings[i + 1];
      return {
        ...setting,
        from: new Date(setting.from),
        to: addDays(new Date(nextItem.from), -1),
        mode: setting.mode || CommonWorkTimeBankSettingMode.NOT_SET,
      };
    }
  });

  return (
    <>
      {!isEmpty(timeBankSettings) ? (
        <Typography>
          {type === "workTimeBank"
            ? t("talentProfile:workTimeBank")
            : t("talentProfile:flexiHours")}
        </Typography>
      ) : (
        <Typography>{t("common:notInUse")}</Typography>
      )}
      <IconButton onClick={() => setIsOpen(true)} sx={{ ml: "4px" }}>
        <EditIcon />
      </IconButton>
      <SettingsDialog
        workTimeBankSettings={formattedTimeBankSettings}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        type={type}
      />
    </>
  );
};
